import type { IconSvgObject } from './types';

const ThumbsDownEllipseIcon: IconSvgObject = [
  ["path", { d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.1127 7.5H9C8.44772 7.5 8 7.94772 8 8.5V13.1492C8 13.3763 8.07728 13.5966 8.21913 13.7739L12 18.5L12.1138 18.4146C13.2208 17.5844 13.6163 16.1047 13.0712 14.8329L12.5 13.5H16.571C17.2653 13.5 17.7484 12.8098 17.5105 12.1575L16.0522 8.15747C15.9083 7.76269 15.5329 7.5 15.1127 7.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ThumbsDownEllipseIcon;
